import { makeStyles, shorthands } from '@fluentui/react-components';

export const useStyles = makeStyles({
  actionCardsList: {
    marginTop: '16px',
  },
  card: {
    height: '165px',
    width: '360px',
    minWidth: '360px',
    ...shorthands.border('1px', 'solid', '#d1d1d1'),
    ...shorthands.padding('12px'),
    ...shorthands.borderRadius('4px'),
    // we are using carousel component to wrap cards, so we cannot use flex to set gap
    marginRight: '12px',
  },
  iconArea: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    ...shorthands.gap('4px'),
  },
  divider: {
    marginTop: '16px',
  },
  cardsMessage: {
    marginTop: '16px',
  },
  cardTitle: {
    ...shorthands.overflow('hidden'),
    textOverflow: 'ellipsis',
    fontWeight: 'bold',
    marginTop: '10px',
    textWrap: 'nowrap',
  },
  cardMessage: {
    ...shorthands.overflow('hidden'),
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    '-webkit-line-clamp': '2',
    '-webkit-box-orient': 'vertical',
    height: '40px',
  },
  cardButton: {
  },
  nameText: {
    color: '#605E5C',
  },
  footer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: '16px',
  },
});
